import {
  type AbstractControl,
  type ValidationErrors,
  type ValidatorFn,
} from '@angular/forms';
import { formatISO } from 'date-fns';

import { type DateFilter } from '../questions/question-date';

export function dateFilterValidator(
  dateFilter: DateFilter,
  dateFormatter: (date: Date) => string = d => (d ? formatISO(d) : ''),
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return dateFilter(control.value)
      ? null
      : {
          [dateFormatter(control.value)]: true,
        };
  };
}
